import { generateSampleDataForReport } from './generate-sample-data-for-report.js';
import { getSampleRecord } from './get-sample-record.js';
export const SampleHelper = {
    getSampleRecord,
    generateSampleDataForReport
};
